import styled from 'styled-components';
import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { device } from '../../../utils/styled-component-mixins';

const ReadMoreCardStyled = styled.div`
  height: 100%;
  box-shadow: 0 16px 80px rgb(91 110 127 / 25%);
  // iOS 16 z-index fix
  -webkit-transform: translate3d(0, 0, 0);

  @media ${device.desktop} {
    .hover-in {
      .overflow-wrapper {
        right: 0;
      }
    }

    .hover-out {
      .overflow-wrapper {
        right: 7rem;
      }
    }
  }

  .readmore-card-wrapper {
    color: inherit;
    height: 100%;
    position: relative;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    overflow: hidden !important;

    @media ${device.desktop} {
      height: 100%;
    }

    &::before {
      box-shadow: var(--card-shadow);
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: -1;
    }
  }

  .readmore-card-wrapper:hover {
    color: inherit;
    text-decoration: none;
  }

  .readmore-card-thumbnail {
    height: 20rem;
    background-size: cover;
  }

  .readmore-card-copy {
    padding: 4rem;
    padding-bottom: 0;
    z-index: 100;

    h2 {
      font-size: 2rem;
      font-weight: 800;
      line-height: 2.4rem;

      @include tablet {
        font-size: 2.2rem;
        line-height: 3.2rem;
      }
    }

    p {
      font-size: 1.4rem;
      margin-bottom: 2rem;
    }

    a {
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
  }

  .animation-wrapper {
    overflow: hidden;
    margin-top: auto;
    margin-bottom: 4rem;
    margin-inline: 4rem;
  }

  .overflow-wrapper {
    position: relative;
    transition: all 0.3s ease-in-out !important;
  }

  .overflow-wrapper > .cta-wrapper {
    align-items: center;
    color: var(--cta-blue);
    display: flex;
    font-size: 1.4rem;
    font-weight: 700;
    span:last-child {
      font-size: 3.2rem;
    }
  }

  @media ${device.tablet} {
    transition: all 0.3s ease-in-out;

    span:first-child {
      transition: all 0.3s ease-in-out;
    }
  }
`;

const ReadMoreCard = ({ thumbnail, title, description, slug }) => {
  const [hoverState, setHoverState] = useState(null);

  useEffect(() => {
    setHoverState('hover-out');
  }, []);

  return (
    <ReadMoreCardStyled
      onMouseEnter={() => setHoverState('hover-in')}
      onMouseLeave={() => setHoverState('hover-out')}
    >
      <a href={`${slug}`} className="readmore-card-wrapper">
        <div
          className="readmore-card-thumbnail"
          style={{ backgroundImage: `url("${thumbnail}")` }}
        ></div>
        <div className="readmore-card-copy">
          <div>
            <h2>{title}</h2>
            <p>{description}</p>
          </div>
        </div>
        <div className={classNames('animation-wrapper', hoverState)}>
          <div className="overflow-wrapper">
            <div className="cta-wrapper">
              <span>Read More</span>
              <span className="material-icons-round" aria-hidden="true">
                chevron_right
              </span>
            </div>
          </div>
        </div>
      </a>
    </ReadMoreCardStyled>
  );
};

export default ReadMoreCard;
